module.exports = __webpack_public_path__ + "img/1555341117.78cb0d68.jpg";